<template>
   <v-dialog name="editRow" v-model="level.dialogValues.dialogShow" data-app="true" persistent max-width="900">
      <v-card>

         <CardUpdatableHeader :row="row" :level="level"/>

         <v-card-text>
            <v-container>
            <v-row>
               <v-col cols="12">
                  <v-text-field v-model="row.cer_cn" :disabled="level.dialogValues.form_disabled" outlined :label="$t('texts._required_code')" :rules="level.dialogOptions.codeRules" required :hint="$t('hints._code')" persistent-hint>
                  </v-text-field>
               </v-col>
            </v-row>
            <v-row>
               <v-col cols="12" sm="6">
                  <h4>{{ $t('subtitles.cer_properties') }}</h4>
               </v-col>
            </v-row>
            <v-row>
               <v-col cols="12" sm="6">
                  <v-switch
                     dense
                     v-model="row.cer_active"
                     :label="$t('texts.cer_active')"
                     :hint="$t('texts.cer_active')"
                     :disabled="level.dialogValues.form_delete" 
                  >
                  </v-switch>
               </v-col>
               <v-col cols="12" sm="6">
                  <v-switch
                     dense
                     v-model="row.cer_masked"
                     :label="$t('texts.cer_masked')"
                     :hint="$t('texts.cer_masked')"
                     :disabled="level.dialogValues.form_delete" 
                  >
                  </v-switch>
               </v-col>
               <v-col cols="12">
                  <v-text-field
                  v-model="row.cer_comments"
                  :disabled="level.dialogValues.form_disabled" 
                  :label="$t('texts.cer_comments')"
                  :hint="$t('hints.cer_comments')"
                  ></v-text-field>
               </v-col>
            </v-row>
            <v-row>
               <v-col cols="12" sm="6">
                  <h4>{{ $t('subtitles.cer_attachments') }}</h4>
               </v-col>
            </v-row>
            <v-row>
               <v-col cols="12" sm="6">
                  <ddoSelect2
                     :callbacks="CRGcallbacks"
                     ref="mySelectCRG"
                     :options="CRGoptions"
                  >
                     <template v-slot:selection="data">
                        <v-chip
                           v-bind="data.attrs"
                           :input-value="data.selected"
                           close
                           @click:close="$refs.mySelectCRG.remove(data.item)"
                        >
                           <span>{{data.item.crg_name}}</span>
                        </v-chip>
                     </template>

                     <template v-slot:item="data">
                        <v-list-item-content>
                           <v-list-item-title>{{data.item.crg_name}} ({{data.item.crg_code}})</v-list-item-title>
                        </v-list-item-content>
                     </template>
                  </ddoSelect2>
               </v-col>
               <v-col cols="12" sm="6">
                  <ddoSelect2
                     :callbacks="CUScallbacks"
                     ref="mySelectCUS"
                     :options="CUSoptions"
                  >
                     <template v-slot:selection="data">
                        <v-chip
                           v-bind="data.attrs"
                           :input-value="data.selected"
                           close
                           @click:close="$refs.mySelectCUS.remove(data.item)"
                        >
                           <span>{{data.item.cus_code}}</span>
                        </v-chip>
                     </template>

                     <template v-slot:item="data">
                        <v-list-item-content>
                           <v-list-item-title>{{data.item.cus_name}} ({{data.item.cus_code}})</v-list-item-title>
                        </v-list-item-content>
                     </template>
                  </ddoSelect2>
               </v-col>
            </v-row>
            <v-row>
               <v-col v-if="!level.dialogValues.form_create" cols="12">
                  <b-badge class="m-1" variant="info">{{ $t('headers.created_on') }}</b-badge>{{ $api._d(row.cer_create,'long') }}<br/>
                  <b-badge class="m-1" variant="info">{{ $t('headers.updated_on') }}</b-badge>{{ $api._d(row.cer_create,'long') }}
               </v-col>
            </v-row>
         </v-container>
            <small>*{{ $t('texts.requiredfield') }}</small>
         </v-card-text>

         <CardUpdatableFooter :row="row" :level="level"/>

      </v-card>
   </v-dialog>

</template>

<script>
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';
import CardUpdatable from '@/components/partials/CardUpdatable.vue';
import CardUpdatableHeader from '@/components/partials/CardUpdatableHeader.vue';
import CardUpdatableFooter from '@/components/partials/CardUpdatableFooter.vue';
import ddoSelect2 from '@/components/ddoSelect2.vue';

export default {
   name: 'CardUpdatableCertificate',
   extends: CardUpdatable,
   components: {
      ddoAlert,
      CardUpdatableHeader,
      CardUpdatableFooter,
      ddoSelect2,
   },

   props: {
   },

   data: function () {
      return {
         loading: false,

         selectedCRG: {},
         CRGcallbacks: {},
         CRGoptions: {
            initial: null,
            selected: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            item_text: "crg_name",
            item_value: "crg_pk",
            item_disabled: "",
            hide_selected: true,
            change_on_remove: true,
            label: i18n.t('texts.cer_registar'),
         },

         selectedCUS: {},
         CUScallbacks: {},
         CUSoptions: {
            initial: null,
            selected: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            item_text: "cus_name",
            item_value: "cus_pk",
            item_disabled: "",
            hide_selected: true,
            change_on_remove: true,
            label: i18n.t('texts.cer_customer'),
         },
      }
   },

   created() {
      this.CRGcallbacks.refresh_rows = this.build_select_crg;
      this.CRGcallbacks.change       = this.change_crg;

      this.CUScallbacks.refresh_rows = this.build_select_cus;
      this.CUScallbacks.change       = this.change_cus;
   },

   methods: {

      async build_select_crg(key=null) {
         this.loading = true;
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'certificateregistar');
         this.loading = false;
         return { errorinfos, api_response }
      },

      /*
       * this dropdown is 'return_object=false'. So, value is an integer, and item is null
       * We have to retrieve item from <select-reference>.items, and store it in this.selectedCRG
       */
      async change_crg(value,item=null) {
         this.row.crg_pk = value;
         if ( item!=null ) {
            this.selectedCRG = item;
         } else {
            this.selectedCRG = this.$api._get_by_pk(this.$refs.mySelectCRG.items,value);
         }
      },

      async build_select_cus(key=null) {
         this.loading = true;
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'customerreseller');
         this.loading = false;
         return { errorinfos, api_response }
      },

      /*
       * this dropdown is 'return_object=false'. So, value is an integer, and item is null
       * We have to retrieve item from <select-reference>.items, and store it in this.selectedCUS
       */
      async change_cus(value,item=null) {
         this.row.cus_pk = value;
         if ( item!=null ) {
            this.selectedCUS = item;
         } else {
            this.selectedCUS = this.$api._get_by_pk(this.$refs.mySelectCUS.items,value);
         }
      },

   },

}
</script>